const steps = [
  {
    number: '01',
    icon: 'ri-user-voice-line',
    title: 'Initial Consultation',
    description: 'We begin with an in-depth conversation about your lifestyle, wardrobe goals, and aesthetic preferences. Whether in our Wellesley Hills studio or at your home or office, we make this experience entirely personal.',
  },
  {
    number: '02',
    icon: 'ri-ruler-line',
    title: 'Precise Measurements',
    description: 'Our master tailors take over 20 individual measurements to create your unique body profile. We capture every nuance — posture, stance, shoulder structure — that makes your garment truly yours.',
  },
  {
    number: '03',
    icon: 'ri-palette-line',
    title: 'Fabric & Style Selection',
    description: 'From our curated collection of 500+ premium fabrics from the world\'s finest mills, you\'ll choose exactly the material, color, pattern, and texture that expresses your personal style.',
  },
  {
    number: '04',
    icon: 'ri-scissors-2-line',
    title: 'Master Crafting',
    description: 'Your garment is hand-cut and constructed using traditional techniques refined over decades. Every seam, buttonhole, and lining is executed with exceptional precision by our expert tailors.',
  },
  {
    number: '05',
    icon: 'ri-checkbox-circle-line',
    title: 'Fittings & Refinement',
    description: 'We schedule one or more fitting sessions to assess the garment on your body. Any refinements — no matter how subtle — are made until the fit is absolutely flawless.',
  },
  {
    number: '06',
    icon: 'ri-gift-line',
    title: 'Delivery & Follow-Up',
    description: 'Your completed garment is pressed, finished, and delivered with the care it deserves. We follow up to ensure your complete satisfaction and remain available for any future adjustments.',
  },
];

export default function AboutProcess() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-[#C9A961] text-xs font-bold tracking-widest uppercase mb-3">How It Works</p>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-5" style={{ fontFamily: 'Playfair Display, serif' }}>
            The <span className="text-[#C9A961]">Tailoring Process</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            A seamless journey from your first conversation to the final garment — guided by decades of experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div key={step.number} className="relative bg-gray-50 rounded-2xl p-8 border border-gray-100 hover:border-[#C9A961]/30 transition-all duration-300 group">
              <div className="absolute top-6 right-6 text-6xl font-bold text-gray-100 group-hover:text-[#C9A961]/10 transition-colors" style={{ fontFamily: 'Playfair Display, serif' }}>
                {step.number}
              </div>
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#C9A961] to-[#B89851] rounded-xl mb-5">
                <i className={`${step.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
                {step.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
